import { getValue } from '../../components/values/Get';
import { FormConfig, FormValues } from '@topdanmark-onlinesolutions/claim-form-types';
import { CustomPageValidatorFn } from '../../types/custom-page-validator';

/**
 * Custom page validation for counterpart page
 * At least one field should be filled
 * @param formValues
 * @param formConfig
 * @returns
 */
export const customPageValidation: CustomPageValidatorFn = (
    formValues: FormValues | undefined,
    formConfig: FormConfig | undefined
) => {
    if (!formValues || !formConfig) {
        return false;
    }

    const fields = [
        'counterpartName',
        'counterpartAddress',
        'mobile',
        'counterpartInsuranceCompany',
        'counterpartLicensePlate'
    ];
    const fieldValues = fields.map((field: string) => getValue(formConfig, formValues, field));
    return fieldValues.some((value: string) => value);
};
